import { COMMON } from './common.enum';

/**
 * Canonical marketing-site page URLs. Used wherever the client links back to
 * the marketing site (app header, footer, error pages, fallback CMS data,
 * etc.) so the URLs are not redeclared per consumer.
 *
 * Trailing-slash convention follows the marketing site's canonical URL form;
 * the marketing site preserves query strings across the trailing-slash
 * redirect.
 */
export const MARKETING_LINK = {
  home: COMMON.MARKETING_SITE_URL,
  whySondermind: `${COMMON.MARKETING_SITE_URL}/why-sondermind/`,
  therapy: `${COMMON.MARKETING_SITE_URL}/therapy/`,
  psychiatry: `${COMMON.MARKETING_SITE_URL}/psychiatry/`,
  insurance: `${COMMON.MARKETING_SITE_URL}/insurance/`,
  articles: `${COMMON.MARKETING_SITE_URL}/resources/articles-and-content/`,
  realResults: `${COMMON.MARKETING_SITE_URL}/real-results/`,
  providerDirectory: `${COMMON.MARKETING_SITE_URL}/provider-directory`,
  contactUs: `${COMMON.MARKETING_SITE_URL}/contact-us/`,
  emergencyResources: `${COMMON.MARKETING_SITE_URL}/emergency-resources`,
  goalSettingGuide: `${COMMON.MARKETING_SITE_URL}/resources/articles-and-content/a-guide-to-setting-goals-in-therapy/`
} as const;

export type MarketingLinkKey = keyof typeof MARKETING_LINK;
export type MarketingLinkUrl = (typeof MARKETING_LINK)[MarketingLinkKey];
